module.exports = __webpack_public_path__ + "static/media/heroCarousel.a1baa332.png";